import { Button, ButtonProps } from 'antd';
import React from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface Props extends ButtonProps {}

export default function CreateBtn(props: Props) {
  const { t } = useTranslation();
  return (
    <Button key="create" type="primary" className="nta-create-btn" icon={<PlusCircleOutlined />} {...props}>
      {t('createNew')}
    </Button>
  );
}
